import { useNavigate } from "@tanstack/react-router";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaQuestionCircle } from "react-icons/fa";

import { useGetMyAccount, useGetMyWriters } from "@/api/queries";
import { hasAdminRights } from "@/auth/shared";
import H2 from "@/components/H2";
import LoadingSmall from "@/components/LoadingSmall";
import RebrandButtonLink from "@/components/RebrandButtonLink";
import Spacer from "@/components/Spacer";
import useWritersTour from "@/components/tour/WritersTour";
import useGetColours from "@/helpers/getColours";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";
import { useUIStateStore } from "@/store/uiStateStore";

import WritersTable from "./WritersTable";

function Writers() {
  const { t } = useTranslation("writers");
  // const selectedAccount = AppState.useState(s => s.selectedAccount);
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const navigate = useNavigate();

  const flags = useFlags();
  const showTourFlag = flags["pd-show-tutorial"];

  const { startTour, endTour } = useWritersTour();

  const startWritersTour = () => {
    startTour();
  };

  const isTunecore = useUIStateStore(state => state.isTunecore);

  const myAccount = useGetMyAccount({
    artistaccountcode: selectedAccount,
  });

  const writers = useGetMyWriters({ aac: selectedAccount });

  const { highlightColour, statusErrorColour } = useGetColours();

  const adminRights = hasAdminRights(myAccount?.data);

  useEffect(() => {
    if (selectedAccount) {
      writers.refetch();
    }
  }, [selectedAccount, writers]);

  return (
    <div className="flex flex-wrap">
      <div className="w-full lg:min-h-screen-minus-header">
        <div className="mx-4 my-12 lg:mx-12 xl:mx-20 2xl:mx-40">
          <div className="flex flex-wrap items-baseline justify-between">
            <div className="flex gap-5">
              <H2>{t("writers:writers-header")}</H2>
              {showTourFlag && (
                <RebrandButtonLink onClick={startWritersTour}>
                  <div className="flex items-center gap-2">
                    {t("tutorial:need-help")}
                    {" "}
                    <FaQuestionCircle className="inline mb-1 text-sentric-orange" />
                  </div>
                </RebrandButtonLink>
              )}
            </div>
            <div>
              <RebrandButtonLink
                plusIcon
                id="btnWriterAddNew"
                onClick={() => {
                  endTour();
                  if (adminRights) {
                    navigate({ to: "/writers/create" });
                  }
                }}
              >
                {t("writers:add-new-writer-button2")}
              </RebrandButtonLink>
            </div>
          </div>
          <Spacer />
          <div
            id="writersTable"
            className={`${
              isTunecore ? "bg-tunecore-dark-element" : " bg-white"
            } rounded-lg p-4 lg:p-8`}
          >
            {!writers.isSuccess && <LoadingSmall />}
            {writers.isSuccess && writers?.data?.writers && (
              <WritersTable
                highlightColour={highlightColour}
                errorColour={statusErrorColour}
                data={writers?.data?.writers}
              />
            )}
          </div>
          <Spacer />
        </div>
      </div>
    </div>
  );
}
export default Writers;
